// extracted by mini-css-extract-plugin
export var growableInput = "_8p-0";
export var tagContainer = "_8p-2";
export var textInput = "_8p-1";